import React from "react";

const TimelessFill = props => (
  <svg viewBox="0 0 26 13" fill="none" {...props}>
    <path
      d="M18.898.25C16.32.25 14.29 1.89 13 3.336 11.672 1.89 9.68.25 7.062.25 3.43.25.5 3.063.5 6.5c0 3.477 2.93 6.25 6.563 6.25 2.617 0 4.609-1.602 5.937-3.047 1.29 1.445 3.32 3.047 5.898 3.047 3.633 0 6.602-2.773 6.602-6.25 0-3.438-2.969-6.25-6.602-6.25zM7.063 9C5.5 9 4.25 7.906 4.25 6.5 4.25 5.133 5.5 4 7.063 4c1.523 0 2.89 1.445 3.671 2.5C9.954 7.594 8.586 9 7.063 9zm11.835 0c-1.523 0-2.89-1.406-3.671-2.5.78-1.055 2.187-2.5 3.671-2.5 1.563 0 2.852 1.133 2.852 2.5 0 1.406-1.29 2.5-2.852 2.5z"
      fill="currentColor"
    />
  </svg>
);

export default TimelessFill;
